// Shared vocabulary of the Stuck Shipments page — mirrors the backend enums StuckAgeBucket / StuckStatusGroup.
export { count, inr, downloadRowsAsCsv, saveBlob, filenameFromResponse } from '../freight-profitability/freightPnlUtils'

/** Age buckets in display order; `key` matches the backend enum and the summary.byBucket keys. */
export const BUCKETS = [
  { key: 'D1_3', label: '1–3 days', rowKey: 'd1To3' },
  { key: 'D3_5', label: '3–5 days', rowKey: 'd3To5' },
  { key: 'D5_15', label: '5–15 days', rowKey: 'd5To15' },
  { key: 'D15_PLUS', label: '> 15 days', rowKey: 'd15Plus' },
]

export const STATUS_GROUPS = [
  { key: 'PICKUP', label: 'Pickup pending' },
  { key: 'DELIVERY', label: 'Delivery pending' },
  { key: 'RTO', label: 'RTO pending' },
]

export const groupLabel = (key) => STATUS_GROUPS.find(g => g.key === key)?.label || key || '—'

/** Threshold choices; 48 h is the mail's cutoff, 24 h is the snapshot's floor. */
export const THRESHOLDS = [
  { value: 24, label: '1 day' },
  { value: 36, label: '36 hours' },
  { value: 48, label: '2 days (mail)' },
  { value: 72, label: '3 days' },
  { value: 96, label: '4 days' },
  { value: 168, label: '7 days' },
]

/** "2h 05m ago" style age for the as-of label. */
export function ageLabel(minutes) {
  if (minutes === null || minutes === undefined) return ''
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes} min ago`
  const h = Math.floor(minutes / 60), m = minutes % 60
  if (h < 24) return `${h}h ${String(m).padStart(2, '0')}m ago`
  return `${Math.floor(h / 24)}d ${h % 24}h ago`
}
